<template>
    <svg
        v-if="viewBox"
        class="icon"
        :style="!ignoreStyle ? `height: ${size}` : ''"
        :viewBox="viewBox"
    >
        <use :xlink:href="`#${icon}`" />
    </svg>
</template>

<script>
export default {
    name: "SvgIcon",
    data() {
        return {
            viewBox: null,
        };
    },
    props: {
        ignoreStyle: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            default: "1em",
        },
    },
    mounted() {
        debugger// eslint-disable-line no-debugger 
        let viewBox = document.querySelector(`#SvgSprite #${this.icon}`);
        if (viewBox) {
            viewBox = viewBox.getAttribute("viewBox");
            this.viewBox = viewBox;
        }
    },
};
</script>

<style>
svg.icon {
    width: auto;
    display: block;
    fill: currentColor;
}
</style>
